const LOG_TYPE = {
  ERROR: 1,
  WARNING: 2,
  INFO: 3,
  SUCCESS: 4
}

const TYPE_BY_DATAWS_TYPE = {
  ERROR: LOG_TYPE.ERROR,
  ATTENTION: LOG_TYPE.WARNING,
  WARNING: LOG_TYPE.WARNING,
  INFO: LOG_TYPE.INFO,
  SUCCES: LOG_TYPE.SUCCESS,
  SUCCESS: LOG_TYPE.SUCCESS
}

const TYPE_BY_BLUEPRINT_TYPE = {
  Error: LOG_TYPE.ERROR,
  Warning: LOG_TYPE.WARNING,
  Information: LOG_TYPE.INFO,
  Success: LOG_TYPE.SUCCESS
}

const EMPTY_LOG = { records: [] }

function parseIfString(rawLog) {
  if (typeof rawLog !== 'string') return rawLog
  if (!rawLog.trim()) return null

  try {
    return JSON.parse(rawLog)
  } catch (error) {
    return { records: [{ type: LOG_TYPE.INFO, Title: '', parsedMessage: rawLog }] }
  }
}

function unwrapRecords(parsedLog) {
  if (!parsedLog || typeof parsedLog !== 'object') return []
  if (Array.isArray(parsedLog)) return parsedLog
  if (Array.isArray(parsedLog.records)) return parsedLog.records

  const wrapperKey = Object.keys(parsedLog).find(key => key.startsWith('ArrayOf'))
  if (!wrapperKey) return []

  const wrapper = parsedLog[wrapperKey]
  if (!wrapper) return []
  if (Array.isArray(wrapper)) return wrapper

  const recordsKey = Object.keys(wrapper)[0]
  if (!recordsKey) return []

  const records = wrapper[recordsKey]
  if (!records) return []
  return Array.isArray(records) ? records : [records]
}

function toRecord(record) {
  if (!record || typeof record !== 'object') {
    return { type: LOG_TYPE.INFO, Title: '', parsedMessage: String(record ?? '') }
  }

  if (typeof record.type === 'number') return record

  if (typeof record.type === 'string') {
    return {
      type: TYPE_BY_BLUEPRINT_TYPE[record.type] || LOG_TYPE.INFO,
      Title: record.objectContext || record.context || '',
      parsedMessage: record.parsedMessage || record.message || ''
    }
  }

  const datawsType = String(record.Type || '').trim().toUpperCase()

  return {
    type: TYPE_BY_DATAWS_TYPE[datawsType] || LOG_TYPE.INFO,
    Title: record.Title || '',
    parsedMessage: record.Message || record.parsedMessage || ''
  }
}

function toLogFromJson(rawLog) {
  const parsedLog = parseIfString(rawLog)
  if (!parsedLog) return { ...EMPTY_LOG }

  return { records: unwrapRecords(parsedLog).map(toRecord) }
}

function hasErrors(log) {
  return Boolean(log && Array.isArray(log.records) && log.records.some(record => record.type === LOG_TYPE.ERROR))
}

export default {
  LOG_TYPE,
  toLogFromJson,
  hasErrors
}
